module.exports = "#define GLSLIFY 1\n#ifdef USE_FOG\n\n\tvarying float fogDepth;\n\n#endif\n"